<template>
  <a-modal :open="open" @cancel="closeForm" class="modal-no-padding">
    <div class="modal-no-padding__body filter-modal-body">
      <a-form layout="vertical" :model="filters">
        <a-form-item label="ФИО">
          <a-input v-model:value="filters.name" placeholder="Фио" />
        </a-form-item>

        <a-form-item label="Должность">
          <a-input
            v-model:value="filters.job_title"
            placeholder="Название должности"
          />
        </a-form-item>

        <a-form-item label="Отдел">
          <a-input
            v-model:value="filters.department"
            placeholder="Название отдела"
          />
        </a-form-item>

        <a-form-item label="Почта">
          <a-input v-model:value="filters.email" placeholder="Почта" />
        </a-form-item>

        <a-form-item label="Телефон">
          <a-input v-model:value="filters.telephone" placeholder="Телефон" />
        </a-form-item>

        <a-form-item label="Группа">
          <a-select
              class="modal-filter-group-select"
            v-model:value="filters.groups"
            mode="multiple"
            :placeholder="'Не выбрано'"
            :not-found-content="'Нет данных'"
          >
            <a-select-option v-for="e in groups" :key="e.id" :value="e.id">
              {{ e.name }}
            </a-select-option>
          </a-select>
        </a-form-item>

        <a-form-item label="Дата добавления" name="created_at">
          <a-date-picker
            v-model:value="filters.created_at"
            type="date"
            placeholder="Выберите дату"
            style="width: 100%"
          />
        </a-form-item>

        <a-form-item label="Последний вход" name="online_from">
          <a-date-picker
            v-model:value="filters.online_from"
            type="date"
            placeholder="Выберите дату"
            style="width: 100%"
          />
        </a-form-item>
      </a-form>
    </div>

    <template #footer>
      <a-divider style="margin: 16px 0" />
      <div class="modal-no-padding__footer">
        <a-row justify="end" :gutter="8">
          <a-col>
            <a-button class="secondary-button" @click="closeForm">
              Отменить
            </a-button>
          </a-col>

          <a-col>
            <a-button class="primary-button" @click="updateFilters">
              Применить
            </a-button>
          </a-col>
        </a-row>
      </div>
    </template>
  </a-modal>
</template>

<script>
import { computed, reactive, ref, toRaw, watch } from "vue";
import { useStore } from "vuex";

export default {
  props: {
    open: Boolean,
    groups: {
      type: Array,
      default: () => [],
    },
    currentGroupId: [Number, String],
  },

  emits: ["close"],

  setup(props, context) {
    const currentFiltersLine = ref("");
    const store = useStore();

    const storedFilters = computed(() => store.state.users.filters);

    const makeLocalFilters = (source = {}) => ({
      name: source.name ?? "",
      job_title: source.job_title ?? "",
      department: source.department ?? "",
      online_from: source.online_from ?? null,
      created_at: source.created_at ?? null,
      email: source.email ?? "",
      telephone: source.telephone ?? "",
      groups: [...(source.groups ?? [])],
      current_group: source.current_group ?? null,
      without_group_only: source.without_group_only ?? false,
      without_limits_only: source.without_limits_only ?? false,
      level_from: source.level_from ?? null,
      level_to: source.level_to ?? null,
    });

    const filters = reactive(makeLocalFilters(storedFilters.value));

    const formatFilterValue = (value) => {
      if (!value) {
        return "";
      }

      if (typeof value?.format === "function") {
        return value.format("DD.MM.YYYY");
      }

      return value;
    };

    const buildInputLineString = () => {
      const parts = [];

      if (filters.name) {
        parts.push(`ФИО: ${filters.name}`);
      }

      if (filters.job_title) {
        parts.push(`Должность: ${filters.job_title}`);
      }

      if (filters.department) {
        parts.push(`Подразделение: ${filters.department}`);
      }

      if (filters.online_from) {
        parts.push(`Дата входа: ${formatFilterValue(filters.online_from)}`);
      }

      if (filters.created_at) {
        parts.push(`Дата создания: ${formatFilterValue(filters.created_at)}`);
      }

      if (filters.email) {
        parts.push(`Почта: ${filters.email}`);
      }

      if (filters.telephone) {
        parts.push(`Телефон: ${filters.telephone}`);
      }

      if (filters.groups?.length) {
        const groupNames = filters.groups
          .map(
            (groupId) =>
              props.groups.find((group) => group.id === groupId)?.name
          )
          .filter(Boolean)
          .join(", ");

        if (groupNames) {
          parts.push(`Группы: ${groupNames}`);
        }
      }

      if (filters.without_group_only) {
        parts.push("Без группы: да");
      }

      currentFiltersLine.value = parts.join(", ");
    };

    const updateFilters = () => {
      const payloadFilters = {
        ...toRaw(filters),
        groups: [...(filters.groups ?? [])],
      };

      if (payloadFilters.groups.length) {
        payloadFilters.without_group_only = false;
      }

      if (props.currentGroupId) {
        payloadFilters.current_group = props.currentGroupId;
      }

      buildInputLineString();

      store.dispatch("users/setUserFilters", {
        filters: payloadFilters,
        filterString: currentFiltersLine.value,
      });

      closeForm();
    };

    const closeForm = () => {
      context.emit("close");
    };

    watch(storedFilters, () => {
      Object.assign(filters, makeLocalFilters(storedFilters.value));
    });

    return {
      filters,
      updateFilters,
      closeForm,
    };
  },
};
</script>

<style scoped lang="scss">
:deep(.ant-form-item-label) {
  padding-bottom: 4px !important;
}

:deep(.ant-form-item) {
  margin-bottom: 12px;
}

.filter-modal-body {
  padding-top: 20px !important;
}
</style>
